import { Button, Flex } from "@chakra-ui/react";
import { useNewOrderStore } from "../../../stores/order.store";
import Tooltip from "../../../components/Tooltip";

/**
 * Base layout buttons. Go back and continue.
 */
export const OrdersNewPageBaseLayoutButton = ({
	validateLabel = "Continuer",
	validateTooltip,
	onValidate,
}: {
	validateLabel?: string;
	validateTooltip?: (isValid: boolean) => string | undefined;
	onValidate?: () => void;
}) => {
	const { goPreviousStep, goNextStep, canGoNextStep } = useNewOrderStore();

	const handleContinue = async () => {
		if (onValidate) {
			return onValidate();
		}
		if (canGoNextStep()) {
			goNextStep();
		}
	};
	const tooltipContent = validateTooltip
		? validateTooltip(canGoNextStep())
		: undefined;
	return (
		<Flex gap="4">
			<Button variant="outline" w="fit-content" onClick={goPreviousStep}>
				Retour
			</Button>
			{tooltipContent === null || tooltipContent === undefined ? (
				<Button
					w="fit-content"
					bgColor="brand.700"
					color="white"
					isDisabled={onValidate === undefined && !canGoNextStep()}
					onClick={handleContinue}
				>
					{validateLabel}
				</Button>
			) : (
				<Tooltip content={tooltipContent}>
					<Button
						w="fit-content"
						bgColor="brand.700"
						color="white"
						isDisabled={onValidate === undefined && !canGoNextStep()}
						onClick={handleContinue}
					>
						{validateLabel}
					</Button>
				</Tooltip>
			)}
		</Flex>
	);
};
